<div class="mat-bg-surface flex flex--column">
  <mat-toolbar>
    <h1>Chargeable Hours</h1>
    <span class="spacer"></span>
    <div class="cell-actions">
      <button
        matIconButton
        matTooltip="Refresh all"
        (click)="refreshAll(true)"
        [class.rotating]="pending()"
        [disabled]="pending()"
      >
        <mat-icon>refresh</mat-icon>
      </button>
    </div>
  </mat-toolbar>

  <lcm-chargeable-hours-table (refreshed)="refreshOne($event)" [timeTable]="timeTable()" [items]="activeItems()" />
</div>
<lcm-po-capacity-table [timeTable]="timeTable()" [items]="activeItems()" class="mat-bg-surface" />

<lcm-team-capacity-table class="mat-bg-surface" />
